/** Shared status, temperature, date, and timeline rules for the portal and the shared link. */

export const COMPLETED_STATUSES = ['DELVD', 'COMPLETE', 'COMPLETED', 'ACC', 'APPRVD', 'BILLD', 'PRINTED', 'AUDIT', 'CANCL'];

export const TIMELINE_STATUS_RANK = {
  DISP: 1, IMEMPTY: 1.5, ARRSHIP: 2, DEPSHIP: 3, ENRTE: 3.5, SPOTTED: 4, SPTLD: 5,
  PICKD: 6, ARRCONS: 7, DEPCONS: 8, DELVD: 9, COMPLETE: 10, COMPLETED: 10,
};

const STATUS_LABELS = {
  CANCL: 'Cancelled',
  DEASSGN: 'Deassigned',
  QUOTE: 'Quote',
  UNAPPRVD: 'Unapproved for billing',
  ENTRY: 'Freight bill entered',
  AVAIL: 'Available',
  ASSGN: 'Assigned',
  PICKD: 'Picked up',
  DISP: 'Dispatched',
  DISPATCHED: 'Dispatched',
  IMEMPTY: 'Empty leg started',
  ENRTE: 'En route',
  ARRSHIP: 'Arrive shipper',
  'ARRIVE SHIPPER': 'Arrive shipper',
  DEPSHIP: 'Depart shipper',
  'DEPART SHIPPER': 'Depart shipper',
  SPOTTED: 'Spotted',
  SPTLD: 'Spotted loaded',
  ARRCONS: 'Arrive consignee',
  'ARRIVE CONSIGNEE': 'Arrive consignee',
  DEPCONS: 'Depart consignee',
  'DEPART CONSIGNEE': 'Depart consignee',
  DELVD: 'Delivered',
  DELIVERED: 'Delivered',
  COMPLETE: 'The trip is done',
  COMPLETED: 'Completed',
  ACC: 'Accessorial charges only',
  APPRVD: 'Approved for billing',
  BILLD: 'Billed',
  PRINTED: 'Freight bill printed',
  AUDIT: 'Order information updated',
};

/** Human label for a history status code. Unknown codes pass through. */
export function getStatusCodeDescription(code) {
  if (!code) return '';
  return STATUS_LABELS[code] || code;
}

/** Status cell: the order's own status. Never the latest history event. */
export function getOrderStatusLabel(status) {
  if (!status) return '—';
  return status === 'CANCL' ? 'Cancelled' : status;
}

/** Haul min/max when both are known. Otherwise the 300/330 thresholds. */
export function getTemperatureClass(tempF, min, max) {
  if (!tempF || tempF === 'NA') return 'temp-green';
  const tempValue = Number(tempF);
  if (isNaN(tempValue)) return 'temp-green';
  if (min != null && max != null) {
    if (tempValue < Number(min)) return 'temp-red';
    return 'temp-green';
  }
  if (tempValue < 300) return 'temp-red';
  if (tempValue <= 330) return 'temp-yellow';
  return 'temp-green';
}

/** Oldest first. Same timestamp uses workflow order. */
export function sortTimeline(events) {
  return [...(events || [])].sort((a, b) => {
    const t = new Date(a.UpdatedOn) - new Date(b.UpdatedOn);
    if (t !== 0) return t;
    return (TIMELINE_STATUS_RANK[a.status] ?? 99) - (TIMELINE_STATUS_RANK[b.status] ?? 99);
  });
}

/** Portal timeline date: 10/20/2026 @ 01:38 PM. */
export function formatEventDate(value) {
  if (!value) return '';
  const date = new Date(value);
  const time = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  return `${date.toLocaleDateString()} @ ${time}`;
}

/** Kilometres from distance_km or distance_miles. Empty input is an em dash. */
export function formatDistanceKm(etaLike) {
  if (!etaLike) return '—';
  if (etaLike.distance_km !== undefined) return `${etaLike.distance_km} km`;
  if (etaLike.distance_miles !== undefined) return `${(etaLike.distance_miles * 1.60934).toFixed(2)} km`;
  return '—';
}
